var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var Site = /** @class */ (function (_super) {
    __extends(Site, _super);
    function Site() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve the site
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/site/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Site.prototype.find = function (queryParams) {
        return this.rawFind(queryParams).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve the site
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/site/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Site.prototype.rawFind = function (queryParams) {
        return this.client.request({
            method: 'GET',
            url: '/site',
            queryParams: queryParams,
        });
    };
    /**
     * Update the site's settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/site/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Site.prototype.update = function (body) {
        return this.rawUpdate(Utils.serializeRequestBody(body, {
            type: 'site',
            attributes: [
                'no_index',
                'favicon',
                'global_seo',
                'name',
                'theme',
                'locales',
                'timezone',
                'require_2fa',
                'ip_tracking_enabled',
            ],
            relationships: ['sso_default_role'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update the site's settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/site/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Site.prototype.rawUpdate = function (body) {
        return this.client.request({
            method: 'PUT',
            url: '/site',
            body: body,
        });
    };
    /**
     * Activate improved timezone management
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/site/activate_improved_timezone_management
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Site.prototype.activateImprovedTimezoneManagement = function () {
        return this.rawActivateImprovedTimezoneManagement().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Activate improved timezone management
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/site/activate_improved_timezone_management
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Site.prototype.rawActivateImprovedTimezoneManagement = function () {
        return this.client.request({
            method: 'PUT',
            url: '/site/activate-improved-timezone-management',
        });
    };
    Site.TYPE = 'site';
    return Site;
}(BaseResource));
export default Site;
//# sourceMappingURL=Site.js.map